import { render, staticRenderFns } from "./ConstructionReport.vue?vue&type=template&id=4f9963f4&"
import script from "./ConstructionReport.vue?vue&type=script&lang=js&"
export * from "./ConstructionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports